import * as GS from 'styles/globalStyles';

export const ScrollBottom = ({ refProp }) => <GS.Container ref={refProp} height={GS.spacing.xs2} />;
